import { render, staticRenderFns } from "./accEdite.vue?vue&type=template&id=1b05959a&scoped=true&"
import script from "./accEdite.vue?vue&type=script&lang=js&"
export * from "./accEdite.vue?vue&type=script&lang=js&"
import style0 from "./accEdite.vue?vue&type=style&index=0&id=1b05959a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05959a",
  null
  
)

export default component.exports